const { request, gql } = require('graphql-request');
const pageResults = require('graph-results-pager');

const { graphAPIEndpoints } = require('./../constants')
const { timestampToBlock } = require('./../utils');

module.exports = {
    async buryShibUserRewards({block = undefined, timestamp = undefined, last_id = ""} = {}) {
        block = block ? block : timestamp ? (await timestampToBlock(timestamp)) : undefined;
        block = block ? `block: { number: ${block} }` : "";

        const result = await request(graphAPIEndpoints.buryShib,
            gql`{
                bury(id: "0xb4a81261b16b92af0b9f7c4a83f1e885132d81e4", ${block}) {
                    id
                    totalSupply
                    users(first :1000, where: {id_gt : "${last_id}"}) {
                        id
                        xShib
                    }
                }
            }`
        );

        return buryShibUsersRewards.callback(result.bury);
    },

    async buryShibUsers({block = undefined, timestamp = undefined} = {}) {
        return pageResults({
            api: graphAPIEndpoints.buryShib,
            query: {
                entity: 'buries',
                selection: {
                    block: block ? { number: block } : timestamp ? { number: await timestampToBlock(timestamp) } : undefined,
                },
                properties: buryShibUsersCallback.properties
            }
        }).then(results => buryShibUsersCallback.callback(results)).catch(err => console.log(err));
    }
}

const buryShibUsersCallback = {
    properties: [
        'id',
        'users {id, xShib, xShibIn, xShibOut, xShibMinted, xShibBurned, xShibOffset, xShibAge, xShibAgeDestroyed, shibStaked, shibStakedUSD, shibHarvested, shibHarvestedUSD, shibOut, shibIn, usdIn, shibOffset, usdOffset}',
        'totalSupply'
    ],

    callback(results) {
        return results.map(entry => ({
            id : entry.id,
            totalSupply: entry.totalSupply,
            users : entry.users.map(eachUser => ({
                id : eachUser.id,
                xShib : Number(eachUser.xShib),
                xShibIn : Number(eachUser.xShibIn),
                xShibOut : Number(eachUser.xShibOut),
                xShibMinted : Number(eachUser.xShibMinted),
                xShibBurned : Number(eachUser.xShibBurned),
                xShibOffset : Number(eachUser.xShibOffset),
                xShibAge : Number(eachUser.xShibAge),
                xShibAgeDestroyed : Number(eachUser.xShibAgeDestroyed),
                shibStaked : Number(eachUser.shibStaked),
                shibStakedUSD : Number(eachUser.shibStakedUSD),
                shibHarvested : Number(eachUser.shibHarvested),
                shibHarvestedUSD : Number(eachUser.shibHarvestedUSD),
                shibOut : Number(eachUser.shibOut),
                shibIn : Number(eachUser.shibIn),
                usdIn : Number(eachUser.usdIn),
                shibOffset : Number(eachUser.shibOffset),
                usdOffset : Number(eachUser.usdOffset)
            }))
        }))
    }
};

const buryShibUsersRewards = {
    properties: [
        'id',
        'users {id, xShib}',
        'totalSupply'
    ],

    callback(results) {
        return {
            id : results.id,
            totalSupply: Number(results.totalSupply),
            users : results && results.users ? results.users.map(eachUser => ({
                id : eachUser.id,
                xShib : Number(eachUser.xShib)
            })) : []
        }
    }
};